import { Contract, ContractInvoice } from "../../Models/Contract";
import warehouseMappers from "../Warehouse/mappers";

const mapToContract = (contract: any): Contract => ({
  id: contract.id,
  title: contract.title,
  startDate: contract.start,
  endDate: contract.end,
  productCode: contract.product_code_merit,
  productName: contract.product_name,
  quantity: contract.quantity,
  client: warehouseMappers.producer.mapToProducer(contract.client),
  price: contract.price,
  contractNumber: contract.contract_number,
  invoices: contract.invoices?.map(mapToContractInvoice) || [],
  comments: contract.comments,
});

const mapToContractInvoice = (inv: any): ContractInvoice => ({
  invoiceNumber: inv.invoice_number,
  date: inv.date,
  quantity: inv.quantity,
});

export default {
  contracts: {
    mapToContract,
    mapToContractInvoice,
  },
};
